// extracted by mini-css-extract-plugin
export var button = "_ds-0";
export var donut = "_ds-1";
export var donutFill = "_ds-3";
export var donutTrack = "_ds-2";